import { NonIndexRouteObject } from "react-router-dom";
import { ErrorElement } from "../../components/error-element/ErrorElement";
import { errorText } from "../../statics/error-text";
import { INVITE_LAYOUT_ID } from "./Invite.Parts";

// LOADER

// WRAPPER

// LAYOUT
/** @todo - try LayoutRoutesProps return type when app routing is more stable */
export const InviteLayout: NonIndexRouteObject = {
  id: INVITE_LAYOUT_ID,
  errorElement: <ErrorElement errorText={errorText} />,
};
